import _ from "lodash";
const View = ({ color = "#F7EEDF", ...props }: any) => {
  return (
    <svg {...props} width="49" height="48" viewBox="0 0 49 48" fill="none">
      <g>
        <path
          d="M48.5 24C48.5 37.2551 37.7551 48 24.5 48C11.2449 48 0.5 37.2551 0.5 24C0.5 10.7449 11.2449 0 24.5 0C37.7551 0 48.5 10.7449 48.5 24Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 23.5205C8.5 14.6029 15.4859 8 24.5 8C33.5141 8 40.5 14.6029 40.5 23.5205C40.5 32.4381 33.5141 39.041 24.5 39.041C22.8807 39.041 21.3258 38.8286 19.8674 38.4261C19.5841 38.3489 19.2847 38.3714 19.0143 38.4905L15.84 39.8909C15.0095 40.2547 14.0726 39.6656 14.0437 38.7577L13.9567 35.9118C13.9439 35.5609 13.7861 35.2358 13.5254 35.0007C10.4123 32.216 8.5 28.1854 8.5 23.5205ZM29.3644 27.8976C29.0956 27.68 28.6796 27.5712 28.1164 27.5712H23.1436L29.0572 19.5264C29.3516 19.1168 29.4988 18.6944 29.4988 18.2592C29.4988 17.8368 29.358 17.4912 29.0764 17.2224C28.8076 16.9408 28.4428 16.8 27.982 16.8H20.6092C20.0332 16.8 19.6044 16.9152 19.3228 17.1456C19.054 17.3632 18.9196 17.7152 18.9196 18.2016C18.9196 18.6624 19.054 19.008 19.3228 19.2385C19.6044 19.456 20.0332 19.5648 20.6092 19.5648H25.2556L19.342 27.6096C19.0476 28.0192 18.9004 28.4352 18.9004 28.8576C18.9004 29.28 19.0348 29.632 19.3036 29.9137C19.5852 30.1952 19.9628 30.3361 20.4364 30.3361H28.1164C28.6924 30.3361 29.1148 30.2272 29.3836 30.0096C29.6524 29.7792 29.7868 29.4208 29.7868 28.9344C29.7868 28.4608 29.646 28.1152 29.3644 27.8976Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
export default View;
